export default __webpack_public_path__ + "3401cb97012c048d9710dc1b6156ce76.png";